import { ModalSize } from "./types";

export const getSizeClass = (size: ModalSize) => {
  return `cpat-modal--${size}`;
};
